import React from "react";

import ContentCore from "../../../core/workingContent";

import "../_index.css";

const TaskRecovery = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskRecovery;
